import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import overViewPropTypes from '../../../../Common/PropTypes/overViewPropTypes';
import ChartUsageCard from '../../Components/ChartUsageCard/ChartUsageCard';

import styles from './FilteredCategoriesUsage.Styles';

function FilteredCategoriesUsage({ usage, images, ...props }) {
  const renderList = () => {
    return _map(usage, usageItem => {
      const { period } = usageItem?.overview || {};
      return (
        <ChartUsageCard
          title={period}
          {...usageItem}
          images={images}
          containerStyle={styles.itemContainerStyle}
        />
      );
    });
  };

  return <View style={styles.containerStyle}>{renderList()}</View>;
}

FilteredCategoriesUsage.propTypes = {
  usage: PropTypes.arrayOf(overViewPropTypes),
  images: PropTypes.object,
};

export default FilteredCategoriesUsage;
